import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-sticker",
  "use": "icon-th-sticker-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-sticker\">\n<path d=\"M21 4H11C9.14409 4.00199 7.36477 4.74012 6.05245 6.05245C4.74012 7.36477 4.00199 9.14409 4 11V21C4.00199 22.8559 4.74012 24.6352 6.05245 25.9476C7.36477 27.2599 9.14409 27.998 11 28H17C17.1075 27.9999 17.2142 27.9826 17.3162 27.9487C20.595 26.855 26.855 20.595 27.9487 17.3162C27.9826 17.2142 27.9999 17.1075 28 17V11C27.998 9.14409 27.2599 7.36477 25.9476 6.05245C24.6352 4.74012 22.8559 4.00199 21 4ZM6 21V11C6 9.67392 6.52678 8.40215 7.46447 7.46447C8.40215 6.52678 9.67392 6 11 6H21C22.3261 6 23.5979 6.52678 24.5355 7.46447C25.4732 8.40215 26 9.67392 26 11V16H23C21.1441 16.002 19.3648 16.7401 18.0524 18.0524C16.7401 19.3648 16.002 21.1441 16 23V26H11C9.67392 26 8.40215 25.4732 7.46447 24.5355C6.52678 23.5979 6 22.3261 6 21ZM18 25.3925V23C18 21.6739 18.5268 20.4021 19.4645 19.4645C20.4021 18.5268 21.6739 18 23 18H25.3925C23.875 20.4375 20.4375 23.875 18 25.3925Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-sticker.svg
// module id = 0oWc
// module chunks = 83